// Import Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';

import { gtm, createAnnualPricingEvent } from '~/common/utils/tracking.js';
import { BASE_ANNUAL_DISCOUNT_PERCENTAGE } from '~/common/utils/consts.js';
import { promoCodeStore } from '../../stores/domain/promoCode';

import styles from './annual-pricing.css';

@inject('offerSuiteStore', 'promoCodeStore')
@observer
export default class AnnualToggleSwitch extends Component {
    handleCheckboxPress() {
        const { offerSuiteStore } = this.props;
        // change the term of the plan and toggle active promo
        offerSuiteStore.setSelectedPlanTerm();
        promoCodeStore.setSelectedPlanTermPromo();
        gtm(createAnnualPricingEvent());
    }

    Checkbox() {
        const { isTermMonthly } = this.props.offerSuiteStore;
        const { size, name } = this.props;

        return (
            <div className={styles['checkbox-wrapper']}>
                <input
                    checked={!isTermMonthly}
                    className={styles.checkbox}
                    id={name}
                    readOnly={true}
                    type={'checkbox'}
                />
                <label
                    className={
                        `${styles['checkbox-label']} ${
                            size && styles[`checkbox-label--${size}`]}`
                    }
                    htmlFor={name}
                ></label>
            </div>
        );
    }

    Detail() {
        const { size, children, isDetailLeft } = this.props;
        const { isTermMonthly } = this.props.offerSuiteStore;

        return (
            <div
                className={
                    `${styles.detail} ${
                        isDetailLeft && styles['detail--right-align']} ${
                        size && styles[`detail--${size}`]}`
                }
            >
                {children ||
                    (isTermMonthly ?
                        <span><strong>PSSST!</strong> Save <strong>over {BASE_ANNUAL_DISCOUNT_PERCENTAGE}</strong> with annual billing!</span>
                        :
                        <span>You're saving <strong>over {BASE_ANNUAL_DISCOUNT_PERCENTAGE}</strong>!</span>)
                }
            </div>
        );
    }

    Label(alignment, labelText) {
        const { isTermMonthly } = this.props.offerSuiteStore;
        const { size, isDetailLeft } = this.props;

        const isActiveLabel = (alignment === 'left') === isTermMonthly;
        const isDetailedLabel = (alignment === 'left') === isDetailLeft;

        return (
            <div
                className={
                    `${styles.label} ${
                        alignment === 'left' ? styles['label--right-align'] : ''} ${
                        size ? styles[`label--${size}`] : ''} ${
                        isActiveLabel ? styles['label--active'] : ''}`
                }
            >
                {labelText}
                {isDetailedLabel && this.Detail()}
            </div>
        );
    }

    render() {
        const { size, leftText, rightText, modifiers } = this.props;
        const classStyles = `${styles.wrapper} ${size ? styles[`wrapper--${size}`] : ''} ${modifiers || ''}`;

        return (
            <div className={classStyles}>
                <div
                    className={`${styles['checkbox-toggle']}`}
                    data-test="billing-term-toggle"
                    onClick={ev => this.handleCheckboxPress(ev)}
                >
                    {this.Label('left', leftText)}
                    {this.Checkbox()}
                    {this.Label('right', rightText)}
                </div>
            </div>
        );
    }
}

AnnualToggleSwitch.defaultProps = {
    isDetailLeft: false,
    name: 'toggle-switch',
    leftText: 'Billed Monthly',
    rightText: 'Billed Annually',
    size: ''
};

AnnualToggleSwitch.propTypes = {
    isDetailLeft: PropTypes.bool,
    leftText: PropTypes.string,
    rightText: PropTypes.string,
    size: PropTypes.string,
    name: PropTypes.string
};
